import React, { useState } from 'react';
import classnames from 'classnames/bind';
import { CollapsibleCard } from 'taboola-ultimate-ui';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { usePermissions } from 'modules/taboola-common-frontend-modules/authentication';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { AdditionalInfoIndication } from './components/AdditionalInfoIndication/AdditionalInfoIndication';
import { Instructions } from './components/Instructions/Instructions';
import { ServerEvents } from './components/ServerEvents/ServerEvents';
import { WebsiteUrlTestEvents } from './components/WebsiteUrlTestEvents/websiteUrlTestEvents';
import styles from './websiteWrapper.module.scss';

const classNameBuilder = classnames.bind(styles);

export const WebsiteWrapper = ({
    websiteCollapsibleCardClassName,
    websiteCollapsibleCardHeaderClassName,
    websiteCollapsibleCardIconClassName,
    isOnBoarding,
}) => {
    const isS2SEnabled = useConfigMatch({ [FEATURE_FLAGS.PIXEL_TESTER_S2S_ENABLED]: 'true' });
    const isS2SPermitted = usePermissions(['REALIZE_PIXEL_TESTER_S2S']);
    const canUseS2S = isS2SEnabled && isS2SPermitted && !isOnBoarding;
    const [isWebsiteUrlCollapsed, setIsWebsiteUrlCollapsed] = useState(false);
    const [isServerEventsCollapsed, setIsServerEventsCollapsed] = useState(true);

    return (
        <div className={styles['container']}>
            <CollapsibleCard
                containerClassName={classNameBuilder('website-collapsible-card', websiteCollapsibleCardClassName)}
                headerClassName={classNameBuilder('website-collapsible-header', websiteCollapsibleCardHeaderClassName)}
                iconClassName={classNameBuilder(websiteCollapsibleCardIconClassName, {
                    'icon-collapsed': isWebsiteUrlCollapsed,
                    'icon-expanded': !isWebsiteUrlCollapsed,
                })}
                bodyClassName={styles['collapsible-body']}
                collapsed={isOnBoarding ? false : isWebsiteUrlCollapsed}
                setCollapsed={setIsWebsiteUrlCollapsed}
                header={<FormattedMessage id="pixel.tester.website.url.title" defaultMessage="Website URL" />}
            >
                <WebsiteUrlTestEvents />
                <Instructions />
                {!isOnBoarding && <AdditionalInfoIndication />}
            </CollapsibleCard>

            {canUseS2S && (
                <CollapsibleCard
                    containerClassName={styles['server-collapsible-card']}
                    headerClassName={styles['server-collapsible-header']}
                    bodyClassName={styles['collapsible-body']}
                    iconClassName={isServerEventsCollapsed ? styles['icon-collapsed'] : styles['icon-expanded']}
                    collapsed={isServerEventsCollapsed}
                    setCollapsed={setIsServerEventsCollapsed}
                    header={
                        <FormattedMessage
                            id="pixel.tester.server.events.section.title"
                            defaultMessage="Server Events"
                        />
                    }
                >
                    <ServerEvents />
                    <AdditionalInfoIndication />
                </CollapsibleCard>
            )}
        </div>
    );
};
